module.exports = __webpack_public_path__ + "static/img/lt-shop.fcf389fc.png";